import React, { MouseEvent } from 'react';

import {
  Button,
  ButtonProps,
} from '@waglabs/button-next';
import { Flex } from '@waglabs/flex-next';

export type StepFooterProps = {
  primaryCtaText: string;
  primaryCtaProps?: Omit<ButtonProps, 'onClick'>;
  secondaryCtaText?: string;
  secondaryCtaProps?: Omit<ButtonProps, 'onClick'>;
  onPrimaryCtaClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  onSecondaryCtaClick?: (event: MouseEvent<HTMLButtonElement>) => void;
};

export const StepFooter = ({
  primaryCtaText,
  primaryCtaProps,
  secondaryCtaText,
  secondaryCtaProps,
  onPrimaryCtaClick,
  onSecondaryCtaClick,
}: StepFooterProps) => (
  <Flex
    justifyContent={secondaryCtaText ? 'space-between' : 'center'}
  >
    {secondaryCtaText && (
      <Button
        {...secondaryCtaProps}
        onClick={onSecondaryCtaClick}
      >
        {secondaryCtaText}
      </Button>
    )}

    <Button
      variant="contained"
      size="large"
      {...primaryCtaProps}
      onClick={onPrimaryCtaClick}
    >
      {primaryCtaText}
    </Button>
  </Flex>
);
